import { styled } from 'styled-components';
import { Label } from '.';

const RadioCounter = ({ label, name, max, value, handleChange }) => {
  return (
    <InputWrapper>
      <Label>{label}</Label>
      <RadioWrapper>
        {[...Array(max).keys()].map(ind => (
          <RadioLabel
            key={`radio-${label}-${ind}`}
            htmlFor={`radio-${label}-${ind}`}
            className={ind + 1 === value && 'checked'}
          >
            {ind + 1}
            <Radio
              id={`radio-${label}-${ind}`}
              name={name}
              type='radio'
              defaultChecked={ind + 1 === value}
              value={ind + 1}
              onClick={evt => evt.target.value && handleChange(ind + 1)}
            />
          </RadioLabel>
        ))}
      </RadioWrapper>
    </InputWrapper>
  );
};

const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const RadioWrapper = styled.div`
  display: flex;
  gap: ${props => props.theme.spaceSm};
`;

const Radio = styled.input`
  appearance: none;
  display: none;
`;

const RadioLabel = styled.label`
  height: ${props => props.theme.sizeH3};
  width: ${props => props.theme.sizeH3};
  min-height: ${props => props.theme.sizeH3};
  min-width: ${props => props.theme.sizeH3};

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: ${props => props.theme.sizeSmall};
  font-weight: ${props => props.theme.headerWeight};
  letter-spacing: ${props => props.theme.headerSpacing};
  color: ${props => props.theme.mutedColor};

  background-color: ${props => props.theme.backgroundColor};

  border: none;
  border-radius: ${props => props.theme.borderFull};

  cursor: pointer;
  transition: ${props => {
    return ['scale', 'background-color', 'border-color', 'color', 'box-shadow']
      .map(style => `${style} ${props.theme.transition}`)
      .join(',');
  }};

  &:hover {
    color: ${props => props.theme.textColor};
  }

  &:active {
    scale: 0.95;
    box-shadow: 0 0 0 4px ${props => props.theme.backgroundColor},
      0 0 0 6px ${props => props.theme.brand + props.theme.clear50};
  }

  &.checked {
    color: ${props => props.theme.backgroundColor};
    background-color: ${props => props.theme.brand};
  }

  // Ignore for now, Firefox does not support :has selector
  // &:has(${Radio}:checked) {
  //   color: ${props => props.theme.backgroundColor};
  //   background-color: ${props => props.theme.brand};
  // }
`;

export default RadioCounter;
